import React, { useEffect, useState } from "react";
import { supabase } from "../supabase";
import GoToTop from "../GoToTop";
import Loader from "./Loader";

function OurCarsPage() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchVehicles();
  }, []);

  async function fetchVehicles() {
    setLoading(true);
    const { data, error } = await supabase
      .from("Vehicles")
      .select("*")
      .order("serial", { ascending: true });
    if (!error) setVehicles(data);
    setLoading(false);
  }

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <GoToTop />
      <div
        className="container section-about web-main pb-4"
        style={{ textAlign: "justify" }}
      >
        <div className="d-flex align-items-center mt-4 mb-3">
          <div className="heading-dash-primary" />
          <h4
            className="fw-bold mb-0 d-flex align-items-center"
            style={{ fontSize: "20px" }}
          >
            {/* <SiSitepoint className="me-2" size={20} /> */}
            Our Vehicles
          </h4>
        </div>

        <div className="row">
          {vehicles.map((item, index) => (
            <div className="col-md-4 mb-3">
              <div
                className="car-card"
                style={{ maxWidth: "100%", width: "100%" }}
                key={index}
              >
                <div className="card-top">
                  {/* <div className="car-bg-white"></div> */}
                  <img
                    src={item.img_url} // replace with your image path
                    alt="Thar"
                    className="car-image"
                  />
                  <div className="rating">⭐ 4.8</div>
                </div>

                <div className="card-content">
                  <div className="title-row">
                    <h2>{item.name}</h2>
                    <span className="badge">{item.seat} Seats</span>
                  </div>

                  <p className="description">{item.tag}</p>

                  <div className="price-row">
                    <div className="price">
                      ₹{item.daily_price} <span>/day</span>
                    </div>

                    {/* <button className="btn book-btn">Book Now</button> */}
                  </div>

                  <div className="features">
                    <span>⛽ {item.fuel}</span>
                    <span>|</span>
                    <span>⚙️ Manual</span>
                    <span>|</span>
                    <span>❄️ AC</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default OurCarsPage;
